import { useRef } from 'react';

export const usePushSubscriptionRef = () => useRef<PushSubscription | null | undefined>();
